/**
 * MobileSplash — Animated splash screen with pulsing halo around the
 * Food Pulse logo. Auto-advances to onboarding after ~1.4s (or the
 * user can tap the logo to skip).
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FP_GREEN = "#9CCA45";

export default function MobileSplash() {
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => {
      const done = localStorage.getItem("fp_mobile_onboarded") === "1";
      nav(done ? "/m" : "/m/welcome/1", { replace: true });
    }, 1400);
    return () => clearTimeout(t);
  }, [nav]);

  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-between py-16 px-6 text-white"
      style={{ background: FP_GREEN }}
      data-testid="mobile-splash"
    >
      <h1 className="text-4xl font-bold tracking-tight">
        Food Pulse<sup className="text-lg">™</sup>
      </h1>

      <div className="relative flex items-center justify-center">
        <div className="absolute w-64 h-64 rounded-full" style={{ background: "rgba(255,255,255,0.14)" }} />
        <div className="absolute w-48 h-48 rounded-full" style={{ background: "rgba(255,255,255,0.22)" }} />
        <div className="relative w-36 h-36 rounded-full bg-white flex items-center justify-center shadow-md">
          <div
            className="w-24 h-24 rounded-full flex items-center justify-center"
            style={{ background: "#653091", color: "#9CCA45", fontFamily: "serif", fontWeight: 700, fontSize: 28 }}
          >
            FP
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center gap-8">
        <p className="text-3xl font-semibold">Social Food Discovery</p>
        <p className="text-sm opacity-80">© Food Pulse {new Date().getFullYear()}</p>
      </div>
    </div>
  );
}
